import { render } from "./BrandRadioFlamingo.vue?vue&type=template&id=7fd32992"
import script from "./BrandRadioFlamingo.vue?vue&type=script&lang=ts"
export * from "./BrandRadioFlamingo.vue?vue&type=script&lang=ts"

import "./BrandRadioFlamingo.vue?vue&type=style&index=0&id=7fd32992&lang=scss"
script.render = render

export default script